// Generated from docs/design/tokens.json. Do not edit by hand.
export const FACE_PILE_LIMIT = 5;
